var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "task-config-container",
      on: { "tab-click": _vm.handleTabChange },
    },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "券膨胀活动", name: "couponEAct" } },
            [
              _c("couponEAct", {
                attrs: { refresh: _vm.refresh, activeTab: _vm.activeTab },
                on: {
                  detailUser: _vm.detailUser,
                  handleEdit: _vm.handleEdit,
                  handleCopy: _vm.handleCopy,
                  addAct: _vm.addAct,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "膨胀明细", name: "expandList" } },
            [
              _c("expandList", {
                attrs: {
                  activeTab: _vm.activeTab,
                  actId: Number(_vm.actId),
                  actTitle: _vm.actTitle,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.activeTab == "couponEAdd"
            ? _c(
                "el-tab-pane",
                { attrs: { label: "添加券膨胀活动", name: "couponEAdd" } },
                [
                  _c("couponEAdd", {
                    attrs: {
                      activeTab: _vm.activeTab,
                      actId: String(_vm.actId),
                    },
                    on: { saved: _vm.saved },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }